import { render, staticRenderFns } from "./OldDocumentUpload.vue?vue&type=template&id=debdc3c0&scoped=true&"
import script from "./OldDocumentUpload.vue?vue&type=script&lang=js&"
export * from "./OldDocumentUpload.vue?vue&type=script&lang=js&"
import style0 from "./OldDocumentUpload.vue?vue&type=style&index=0&id=debdc3c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debdc3c0",
  null
  
)

export default component.exports